// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryMutateHook on POST /squares/grid-add.

import {
  useMutation,
  useQueryClient,
  type QueryClient,
  type UseMutationOptions,
} from "@tanstack/react-query";
import type {
  typeSquaresGridAddBody,
  typeSquaresGridAddOutput200,
} from "../../sdk/squares/postSquaresGridAdd";
import useCallSdk from "../../sdk-helpers/useCallSdk";

type Options = Omit<
  UseMutationOptions<
    typeSquaresGridAddOutput200,
    unknown,
    typeSquaresGridAddBody,
    unknown
  >,
  "mutationFn"
>;

let invalidationTimer: ReturnType<typeof setTimeout> | null = null;

// 150ms of silence before invalidating: a burst of mutations (a row action
// repeated across a table selection) triggers one refetch, not one per call.
export function invalidateRelated({
  queryClient,
}: {
  queryClient: QueryClient;
}): void {
  if (invalidationTimer) {
    clearTimeout(invalidationTimer);
  }
  invalidationTimer = setTimeout(() => {
    void queryClient.invalidateQueries({
      queryKey: ["post:squares:squaresPoolGet", "svc:contest-api"],
    });
    void queryClient.invalidateQueries({
      queryKey: ["post:squares:squaresSeasonStartPreview", "svc:contest-api"],
    });
    void queryClient.invalidateQueries({
      queryKey: ["post:squares:squaresRulesGet", "svc:contest-api"],
    });
  }, 150);
}

export default function useSquaresGridAdd(options?: Options) {
  const { callSdk } = useCallSdk();
  const queryClient = useQueryClient();
  const resolvedOptions = options ?? {};

  return useMutation({
    mutationFn: callSdk().postSquaresGridAdd,
    ...resolvedOptions,
    // TanStack Query v5 hands onSuccess four arguments
    // (data, variables, onMutateResult, context). Forward all four. Dropping
    // the last one makes the caller's own onSuccess a type error at every
    // generated mutation hook.
    onSuccess: (data, variables, onMutateResult, context) => {
      resolvedOptions.onSuccess?.(data, variables, onMutateResult, context);
      invalidateRelated({ queryClient });
    },
  });
}
